import React from 'react'
import { Path, Svg } from 'react-native-svg'
import { IconProps } from '@tabler/icons-react-native'

export default function IconSunglassesFilled({
  size = 24,
  ...props
}: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2614 9.18526C11.6031 9.31027 12 9.31455 12 9.31455C12 9.31455 12.3969 9.31027 12.7386 9.18526C14.4319 8.56578 15.6883 8.16112 17.7284 8.04016C20.127 7.83366 23.1866 8.49069 23.1866 8.49069C23.1866 8.49069 24 8.71596 24 9.33544C23.9997 10.2723 23.3291 10.2271 23.2034 10.2186C23.1956 10.2181 23.1899 10.2177 23.1866 10.2177C23.0941 10.628 23.0207 11.0686 22.9462 11.5157C22.6457 13.3193 22.3275 15.2291 20.6674 15.6804C20.055 15.8314 17.0259 16.3374 15.6208 15.6429C14.5458 14.9731 13.8876 13.4582 13.4054 12.3483C13.1443 11.7472 12.9348 11.2649 12.7386 11.1C12.4258 10.8372 12 10.8169 12 10.8169C12 10.8169 11.5742 10.8372 11.2614 11.1C11.0652 11.2649 10.8557 11.7472 10.5946 12.3483C10.1124 13.4582 9.45425 14.9731 8.37921 15.6429C6.97412 16.3374 3.94504 15.8314 3.33257 15.6804C1.67252 15.2291 1.3543 13.3193 1.05379 11.5157C0.979285 11.0686 0.905872 10.628 0.813372 10.2177C0.810056 10.2177 0.804356 10.2181 0.796562 10.2186C0.670856 10.2271 0.000322646 10.2723 0 9.33544C0 8.71596 0.813372 8.49069 0.813372 8.49069C0.813372 8.49069 3.87299 7.83366 6.27158 8.04016C8.31169 8.16112 9.56812 8.56578 11.2614 9.18526Z"
        fill={props.color}
      />
    </Svg>
  )
}
